import { autoDarkColors } from "@/modules/theme/color/darkModeColor.ts";
import type { ThemeProps, ThemeVarGetters, ThemeVariant } from "@/modules/theme/types.ts";

import png from "@/styles/rackzar/apple-touch-icon.png?url";
import icon from "@/styles/rackzar/favicon.ico?url";
import favicon from "@/styles/rackzar/favicon.svg?url";
import loginIntroBg from "@/styles/rackzar/login-bg.svg?url";
import logoDark from "@/styles/rackzar/logo-dark.svg?url";
import loginLogo from "@/styles/rackzar/logo.svg";
import logo from "@/styles/rackzar/logo.svg?url";

export function makeTheme(variant: ThemeVariant) {
    const { isDark } = variant;

    const baseColors: ThemeVarGetters = autoDarkColors({
        "color-primary": "#f96d00",
        "color-secondary": "#e5e5e5",
    });

    return {
        ...baseColors,

        "logo-image": isDark ? `url("${logoDark}")` : `url("${logo}")`,

        "button-border-radius": "24px",

        "header-logo-width": "110px",
        "header-logo-height": "16px",

        "sidenav-bg-color": isDark ? "transparent" : "#393E46",
        "sidenav-item-border": "1px solid transparent",
        "sidenav-item-icon-color": "var(--color-primary)",
        "sidenav-item-bg-color": "transparent",
        "sidenav-item-text-color": "#FFFFFF",
        "sidenav-item-before-width": "1px",
        "sidenav-item-hover-bg-color": "#FFFFFF0C",
        "sidenav-item-hover-icon-color": "var(--color-primary)",
        "sidenav-item-hover-text-color": "#FFFFFF",
        "sidenav-item-active-bg-color": "#FFFFFF19",
        "sidenav-item-active-icon-color": "var(--color-primary)",
        "sidenav-item-active-text-color": "#FFFFFF",
        "sidenav-item-active-before-bg-color": "var(--color-primary)",

        //#region Login
        "login-body-bg-color": "var(--color-text)",
        "login-body-bg-size": "cover",
        "login-body-text-color": "var(--color-white)",
        "login-justify-content": "space-between",
        "login-align-items": "stretch",

        "login-intro-display": "flex",
        "login-intro-bg-image": `url("${loginIntroBg}")`,
        "login-intro-bg-size": "contain",
        "login-intro-bg-position": "50% 25%",
        "login-intro-text-align": "left",
        "login-intro-flex-direction": "column",
        "login-intro-justify-content": "flex-end",
        "login-intro-align-items": "flex-start",
        "login-intro-padding": "60px",
        "login-title-font-size": "36px",
        "login-title-text-color": "",
        "login-title-font-weight": 300,
        "login-title-line-height": 1,
        "login-title-max-width": "400px",
        "login-title-padding": "0 0 16px 0",
        "login-subtitle-font-size": "13px",
        "login-subtitle-max-width": "400px",

        "login-form-title-font-size": "20px",
        "login-form-bg-color": "#F2F2F2",
        "login-form-text-color": "var(--color-text)",
        "login-form-input-border-color": "#dbe2e9",
        "login-form-button-border-radius": "var(--input-border-radius)",
        "login-form-or-text-color": "#dbe2e9",
        "login-form-or-border-color": "#dbe2e9",
        "login-form-google-bg-color": "#007bf5",
        "login-form-more-text-color": "var(--color-white)",
        "login-form-more-bg-color": "var(--color-primary)",
        "login-form-more-border-color": "var(--color-primary)",
        //#endregion
    } satisfies ThemeVarGetters;
}

export const props: ThemeProps = {
    favicon,
    icon,
    png,
    loginLogoImg: {
        src: loginLogo,
        style: {
            maxWidth: "160px",
        },
    },
};
